// export default async function delay(delayInms) {
//   return new Promise(resolve => {
//     setTimeout(() => {
//       resolve(2);
//     }, delayInms);
//   });
// }

export const Delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

